import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import plugins from "./plugins/install";
import useVuetify from "./plugins/vuetify";
import { CONFIGS, NODE_ENV, APP_TOKEN } from "./constants";

import "animate.css";
import "./scss/index.scss";
// import "./layouts";
// import "./components";

try {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
} catch (error) {
  // ignore
}

Vue.use(plugins, { configs: CONFIGS, store });

if (NODE_ENV === "development" && APP_TOKEN) {
  store.commit("auth/SET_TOKEN", { token: APP_TOKEN });
}

Vue.config.productionTip = false;

new Vue({
  // router,
  // store,
  i18n,
  // vuetify: useVuetify(store),
  render: h => h(App)
}).$mount("#app");
